import { useTheme } from '../../hooks/themeProvider';
import { useTranslation } from 'react-i18next';
import './themeToggle.css';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  
  return (
    <label 
      className='theme-toggle-switch'
      htmlFor='themeToggle'
    >
      <span className='sr-only'>
        {t('aria-label.themeToggle.desc')}
      </span>
      <input
        id='themeToggle'
        type='checkbox' 
        checked={theme === 'dark'}
        onChange={toggleTheme}
        role='switch'
        aria-label={t('aria-label.themeToggle.desc')}
        aria-checked={theme === 'dark'}
      />
      <span className='slider round'>
      </span>
    </label>
  );
}
